var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"app-status-link"},[_c('a',{attrs:{"href":"https://audimexico-648.freshstatus.io","target":"_blank"}},[_vm._v(_vm._s(_vm.$t('info.currentStatus')))]),_vm._v(" \n  "),_c('i',{staticClass:"fas fa-external-link-alt"})])}
var staticRenderFns = []

export { render, staticRenderFns }